import type {
  BankMatch,
  BankMerchantLink,
  PaymentBankLinks,
} from '../../model/payment-bank-links.js';
import type {
  BankMatchDto,
  BankMerchantLinkDto,
  PaymentBankLinksDto,
} from '../dto/payment-bank-links.dto.js';

const toBankMerchantLink = (dto: BankMerchantLinkDto): BankMerchantLink => ({
  id: dto.id,
  description: dto.description,
});

const toBankMatch = (dto: BankMatchDto): BankMatch => ({
  occurrenceId: dto.occurrenceId,
  description: dto.description,
});

export const toPaymentBankLinks = (dto: PaymentBankLinksDto): PaymentBankLinks => ({
  merchants: dto.merchants.map(toBankMerchantLink),
  matches: dto.matches.map(toBankMatch),
});
